import { Auth } from 'aws-amplify';

const signinAuth = async user => {
  await Auth.signIn(user.email, user.password);
};

export default signinAuth;



// WEBPACK FOOTER //
// ./src/services/auth/signinAuth.js